import { render, staticRenderFns } from "./Movement.html?vue&type=template&id=46d75ec5&scoped=true&external"
import script from "./Movement.js?vue&type=script&lang=js&external"
export * from "./Movement.js?vue&type=script&lang=js&external"
import style0 from "./Movement.scss?vue&type=style&index=0&id=46d75ec5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d75ec5",
  null
  
)

export default component.exports